





import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import { ILogin } from "@/@types/auth/auth";
import { auth } from "@/config/host.config";

@Component({
  name: "authorized",
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
  methods: {
    ...mapActions({
      onLogin: "onLogin",
    }),
  },
})
export default class Authorized extends Vue {
  onLogin!: ({ login, password }: ILogin) => void;
  isAuthorized!: boolean;
  onlineInterval: ReturnType<typeof setInterval> | undefined;

  async chekin(): Promise<void> {
    const url = auth.access;
    const data = { status: "Online", path: this.$route.name };
    try {
      const tuktuk = await this.$axios.post(url, data);
      if (tuktuk.status === 200) {
        this.messagesHandler(tuktuk.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  messagesHandler(messages: any): void {
    return;
  }

  async getApi(): Promise<void> {
    try {
      const api = await this.$axios.get(auth.getAPI);
      // if (api.status === 200) console.table(api.data[7].routes);
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.getApi();
    if (this.$store.getters.getAccess || this.$store.getters.getRefreshToken)
      this.chekin();

    this.onlineInterval = setInterval(() => {
      if (this.isAuthorized) {
        this.chekin();
      }
    }, this.$second(10));
  }

  destroyed(): void {
    clearInterval(this.onlineInterval);
  }
}
